import { useBubbleBulkRemoveUpcomingRsvps } from "@crowdcoursing/api/openapi";
import { useCallback } from "react";

import { useToast } from "~hooks/useToast";

const tRemovedOne = "Successfully removed 1 RSVP";
const tRemovedMany = (count: number) => `Successfully removed ${count} RSVPs`;
const tRemoveFailed = "Could not remove the selected RSVPs";

export function useBulkRemoveUpcomingRsvps(bubbleId: string | undefined, refetch?: () => void) {
  const toast = useToast();
  const { isPending, mutate } = useBubbleBulkRemoveUpcomingRsvps();

  const removeRsvps = useCallback(
    (rsvpIds: string[]) => {
      if (rsvpIds.length === 0 || !bubbleId) {
        return;
      }

      mutate(
        {
          body: { eventTimeRsvps: rsvpIds },
          pathParams: { bubbleId },
        },
        {
          onError: () => {
            toast.error(tRemoveFailed);
          },
          onSuccess: () => {
            refetch?.();
            toast.success(rsvpIds.length === 1 ? tRemovedOne : tRemovedMany(rsvpIds.length));
          },
        },
      );
    },
    [bubbleId, mutate, refetch, toast],
  );

  return { isPending, removeRsvps };
}
